import React from 'react'
interface OptionsSummaryLabelProps {
  title: string
  label: string[] | string
}

// Internal component for a single option label(s)
const OptionsSummaryLabel = ({ title, label }: OptionsSummaryLabelProps) => {
  // No label
  if (!label) {
    return <strong>{title}</strong>
  }

  return (
    <>
      <strong>{title} : </strong>
      {computeLabel(label)}
    </>
  )

  function computeLabel(label: string | string[]) {
    if (Array.isArray(label)) {
      return label.map((subLabel) => {
        if (Array.isArray(subLabel)) {
          if (Array.isArray(subLabel[1])) {
            return (
              <React.Fragment key={subLabel[0]}>
                {subLabel[0]}
                <span>{computeLabel(subLabel[1])}</span>
              </React.Fragment>
            )
          } else {
            return (
              <span key={subLabel[0]}>
                <strong>{subLabel[0]}</strong>: {subLabel[1]}
              </span>
            )
          }
        } else {
          return <React.Fragment key={subLabel}>{subLabel}</React.Fragment>
        }
      })
    } else {
      return label
    }
  }
}
export default OptionsSummaryLabel
